<template>

    <wizard-step-card
            header="Widerruf | Artikel zurück senden"
            :reason="_getCurrentReason"
            v-on:stepdone="stepDone"
            v-on:abbort="$emit('abbort')"
            btn-abbort-name="Beenden"
    >

        <div class="row">

            <div class="col-6">

                <info-header>
                    <template slot="titel">
                        Wideruf der Bestellung
                    </template>

                    <template slot="leed">
                        Bitte lesen Sie sorgfältig unsere Widerufsbelehrung
                    </template>
                </info-header>

                <div style="font-size: .85em">

                    <p>
                    Sie haben das Recht, binnen 30 Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt 30 Tage ab dem Tag an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist, die Waren in Besitz genommen haben bzw. hat.
                    </p>

                    <p>
                    Um Ihr Widerrufsrecht auszuüben, müssen Sie uns mittels einer eindeutigen Erklärung über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren.
                    </p>

                    <p>
                    Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
                    </p>

                    <div v-show="showWholeWhitedraw" class="animated slideIn">
                    <h5>Folgen des Widerrufs</h5>

                    <p>
                    Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.

                    Wir können die Rückzahlung verweigern, bis wir die Waren wieder zurückerhalten haben oder bis Sie den Nachweis erbracht haben, dass Sie die Waren zurückgesandt haben, je nachdem, welches der frühere Zeitpunkt ist.

                    Sie haben die Waren unverzüglich und in jedem Fall spätestens binnen 30 Tagen ab dem Tag, an dem Sie uns über den Widerruf dieses Vertrags unterrichten, uns zurückzusenden oder zu übergeben. Die Frist ist gewahrt, wenn Sie die Waren vor Ablauf der Frist von 30 Tagen absenden.

                    Sie müssen für einen etwaigen Wertverlust der Waren nur aufkommen, wenn dieser Wertverlust auf einen zur Prüfung der Beschaffenheit, Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang mit ihnen zurückzuführen ist.

                    </p>

                    Ende der Widerrufsbelehrung

                    <h5>Allgemeine Hinweise</h5>


                    1) Bitte vermeiden sie Beschädigungen und Verunreinigungen der Ware. Senden Sie die Ware möglichst in Originalverpackung mit sämtlichem Zubehör und mit allen Verpackungsbestandteilen an uns zurück. Verwenden Sie ggf. eine schützende Umverpackung. Wenn Sie die Originalverpackung nicht mehr besitzen, sorgen Sie bitte mit einer geeigneten Verpackung für einen ausreichenden Schutz vor Transportschäden

                    2) Senden Sie die Ware möglichst nicht unfrei an uns zurück.

                    3) Bitte beachten Sie, dass die vorgenannten Ziffern 1) – 2) nicht Voraussetzung für die wirksame Ausübung des Widerrufsrecht sind.

                    </div>

                    <a @click="showWholeWhitedraw = !showWholeWhitedraw" href="#">Weiterlesen..</a>
                </div>

            </div>

            <div class="col-6">

                <info-header>
                    <template slot="titel">
                        Rücksendung der Ware
                    </template>

                    <template slot="leed">
                        Informationen zur Rücksendung der Ware
                    </template>
                </info-header>

                <div class="center" style="font-size: .85em">
                    <p><b>Schicken Sie die Ware mit einem Versanddienstleister Ihrer Wahl an:</b></p>

                    <p>
                        WMK Trading GmbH<br>
                        Waltrup 16<br>
                        48341 Altenberge (Deutschland)
                    </p>

                    <b>Rücksenschein zum ausdrucken</b>
                    <p>
                        Wenn Sie einen Rücksendeschein zum ausdrucken bevorzugen, kicken Sie bitte auf "Nächster Schritt" um ein
                        Label von uns zu erhalten. Sonst können Sie den Assistenten an dieser Stelle beenden.
                    </p>

                    <!--
                    <b>
                        Bitte beachten Sie, das wir eine Versandpauschale von 4,90€ für die nutzung des Labels berechnen!
                    </b>
                    -->

                </div>

            </div>

        </div>

    </wizard-step-card>

</template>

<script>
    import InfoHeader from '../../elements/InfoHeader'
    import WizardStepCard from '../../elements/WizardStepCard'

    export default {
        name: "whitedraw",

        data: () => ({
            showWholeWhitedraw: false
        }),

        components: {
            InfoHeader,
            WizardStepCard
        },

        computed: {
            _getCurrentReason () {

                let reasonCode = this.$store.getters.getReason

                return this.$store.getters.getReasons[ reasonCode ] || 'Fehler - nicht gefunden!'
            },

            _getCurrentOrder () {

                let currentOrderId = this.$store.getters.getCurrentOrderId

                return this.$store.getters.getOrders.find(x => x.id === currentOrderId)
            }
        },

        methods: {

            stepDone () {
                this.$emit('stepdone')
            }
        }
    }
</script>

<style scoped>

</style>

